module.exports = __webpack_public_path__ + "img/loghi-cantine-divinea-mobile.a2e46163.jpg";